module.exports = __webpack_public_path__ + "assets/img/about/about_07.jpg";